import React, { Component } from 'react'
import Door from './Door'

class Corridor extends Component {
  componentDidMount () {
    if (this.lastSection && !this.listener) {
      this.listener = () => { this.props.onTransitionEnd() }
      console.log('set listener')
      this.lastSection.addEventListener('transitionend', this.listener)
    }
  }

  componentWillUnmount () {
    if (this.lastSection) {
      this.lastSection.removeEventListener('transitionend', this.listener)
      this.listener = null
    }
  }

  render () {
    const { children, delay, isLast } = this.props
    return (
      <div className='section section--0 animate' style={{transitionDelay: `${delay}s`}}>
        <div className='wall wall--left' />
        <div className='wall wall--right' />
        <div className={`section section--1 animate forward`} style={{transitionDelay: `${delay + 1}s`}} ref={(cmp) => {
          if (cmp && isLast) {
            this.lastSection = cmp
          }
        }}>
          <div className='wall wall--left' />
          <div className='wall wall--right' />
          { isLast ? (
            <Door delay={delay + 2} />
            ) : children}
        </div>
      </div>
    )
  }
}

export default Corridor



// WEBPACK FOOTER //
// ./src/components/Corridor.js